import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";

const BetLockMatchOddsModal = ({ show, onClose, betLockMarketType, matchOddsUsers }) => {
  const { marketId } = useParams();

  const [betLock, setBetLock] = useState("selected-users");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    if (!show) return;
    const initiallySelected = matchOddsUsers.filter(u => u.blocked === true);
    setSelectedUsers(initiallySelected);
  }, [show, matchOddsUsers]);

  useEffect(() => {
    if (matchOddsUsers.length === 0) return;
    if (selectedUsers.length === matchOddsUsers.length) {
      setBetLock("all-users");
    } else {
      setBetLock("selected-users");
    }
  }, [selectedUsers, matchOddsUsers]);

  const handleUserToggle = (user) => {
    setSelectedUsers(prev => {
      const exists = prev.some(u => u._id === user._id);
      return exists
        ? prev.filter(u => u._id !== user._id)
        : [...prev, user];
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const finalSelectedUsers =
      betLock === "all-users" ? matchOddsUsers : selectedUsers;

    const params = {
      bet_lock: betLock,
      selected_users: finalSelectedUsers.map(u => u._id),
      cat_mid: marketId
    };

    try {
      let response = null;

      if (betLockMarketType === "Match Odds") {
        response = await axiosInstance.post("/master/save-bet-lock", params);
      } else if (betLockMarketType === "Other Markets") {
        response = await axiosInstance.post("/master/save-bet-lock/other", params);
      }

      if (response?.data?.R) {
        setSuccessMessage(response.data.M);
      }

      setTimeout(() => {
        setSuccessMessage("");
        onClose();
      }, 2000);
    } catch (err) {
      console.error(err);
    }
  };

  if (!show) return null;

  return (
    <>
      <style>
        {`
          .betlock-modal-overlay {
            position: fixed;
            inset: 0;
            background: rgba(0,0,0,0.5);
            z-index: 1050;
          }
          .betlock-modal-wrapper {
            position: fixed;
            inset: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1051;
          }
          .betlock-modal {
            background: #fff;
            width: 100%;
            max-width: 800px;
            border-radius: 6px;
            box-shadow: 0 10px 25px rgba(0,0,0,0.25);
          }
          .betlock-modal-body {
            padding: 20px;
            color: #000;
          }
          .betlock-inline-row {
            display: flex;
            align-items: center;
            gap: 15px;
            flex-wrap: wrap;
          }
        `}
      </style>

      <div className="betlock-modal-overlay" onClick={onClose} />

      <div className="betlock-modal-wrapper">
        <div className="betlock-modal">
          <div className="betlock-modal-body">
            <h5>{betLockMarketType} - Bet Locker</h5>

            {successMessage && (
              <div className="alert alert-success mt-3">
                {successMessage}
              </div>
            )}

            <form>
              <div className="betlock-inline-row mt-3">
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    id="betlock_all"
                    name="bet_lock"
                    className="form-check-input"
                    checked={betLock === "all-users"}
                    onChange={() => setBetLock("all-users")}
                  />
                  <label className="form-check-label" htmlFor="betlock_all">
                    All Users
                  </label>
                </div>

                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    id="betlock_selected"
                    name="bet_lock"
                    className="form-check-input"
                    checked={betLock === "selected-users"}
                    onChange={() => setBetLock("selected-users")}
                  />
                  <label className="form-check-label" htmlFor="betlock_selected">
                    Selected Users
                  </label>
                </div>

                <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                  Save
                </button>

                <button type="button" className="btn btn-danger" onClick={onClose}>
                  Cancel
                </button>
              </div>

              {betLock === "selected-users" && (
                <div className="mt-3">
                  {matchOddsUsers.map(user => {
                    const isChecked = selectedUsers.some(u => u._id === user._id);
                    return (
                      <div className="form-check" key={user._id}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`chk_user_${user._id}`}
                          checked={isChecked}
                          onChange={() => handleUserToggle(user)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`chk_user_${user._id}`}
                        >
                          {user.uname}
                        </label>
                      </div>
                    );
                  })}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default BetLockMatchOddsModal;
